import React from 'react';
import PropTypes from 'prop-types';

import { getMatchedSegments } from '../../util/seatingChartUtils';

const ResultItem = ({ affiliation, guestSelect, name, token }) => {
  const nameSections = getMatchedSegments(name, token);
  return (
    <div className="sc__guest-result" onClick={guestSelect}>
      <span className="sc__result-name">
        {nameSections.start}
        <strong>{nameSections.match}</strong>
        {nameSections.end}
      </span>
      <span className="sc__result-affiliation">{affiliation}</span>
    </div>
  );
};

ResultItem.propTypes = {
  affiliation: PropTypes.string,
  guestSelect: PropTypes.func,
  name: PropTypes.string,
  token: PropTypes.string,
};

export default ResultItem;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Tables/Seat/ResultItem.jsx